import { createGlobalStyle } from 'styled-components';
export default createGlobalStyle`

*{
    padding:0;
    margin:0;
    box-sizing:border-box;
    text-decoration: none;
    font-family: 'Inter', sans-serif;
}
`